<template>
    <div class="wrapper" :style="{ backgroundColor }">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
            <defs>
                <filter id="goo" x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur
                        in="SourceGraphic"
                        stdDeviation="2"
                        result="blur"
                    />
                    <feColorMatrix
                        in="blur"
                        mode="matrix"
                        values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -1"
                        result="goo"
                    />
                    <feBlend in="SourceGraphic" in2="goo" />
                </filter>
            </defs>
        </svg>
        <div class="loader">
            <span :style="{ backgroundColor: color }" />
            <span :style="{ backgroundColor: color }" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        backgroundColor: {
            type: String,
            required: true
        },
        color: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped lang="sass">
.wrapper
    position: absolute
    inset: 0
    z-index: 1
    display: grid
    place-content: center
    flex-grow: 1
    border-radius: 5px

.loader
    display: flex
    align-items: center
    filter: url('#goo')

    span
        border-radius: 50%

        &:nth-child(1)
            position: absolute
            width: 8px
            height: 8px
            transform: scale(1)
            animation: pulse infinite 3s

        &:nth-child(2)
            width: 8px
            height: 8px
            transform: translateX(-1em)
            animation: dance infinite 3s ease-in-out

svg
    position: absolute
    overflow: visible

@keyframes dance
    50%
        transform: translateX(1em)

@keyframes pulse
    20%, 75%
        transform: scale(2.5)
        transition-timing-function: ease-out
    0%, 50%, 100%
        transform: scale(1)
        transition-timing-function: ease-in
</style>
